"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given date is same as or after than specified date.
 *
 * @export
 * @class IsSameOrAfterValidator
 * @implements {PropertyValidator<Date>}
 */
class IsSameOrAfterValidator {
    constructor(date) {
        this.date = date;
    }
    isValid(input) {
        if (input) {
            return input.getTime() >= this.date.getTime();
        }
        return false;
    }
}
exports.IsSameOrAfterValidator = IsSameOrAfterValidator;
//# sourceMappingURL=IsSameOrAfterValidator.js.map